import {createEntityAdapter, createSlice, SerializedError} from "@reduxjs/toolkit";
import {FeAdmin} from "./types";
import {RootState} from "../../../redux/store";
import {
    createAdminThunk,
    getAdminThunk,
    listAdminsThunk,
    updateAdminStatusThunk,
    updateAdminThunk
} from "./admins.thunk";

const adminAdapter = createEntityAdapter<FeAdmin>();

type ErrorMap = {
    [id: string]: SerializedError | undefined;
};

const adminsSlice = createSlice({
    name: 'admins',
    initialState: adminAdapter.getInitialState({errors: {} as ErrorMap}),
    reducers: {
        clearAllAdminErrors(state) {
            state.errors = {};
        }
    },
    extraReducers: builder =>
        builder
            .addCase(listAdminsThunk.fulfilled, (state, {payload}) => {
                state.errors.list = undefined;
                adminAdapter.setAll(state, payload);
            })
            .addCase(listAdminsThunk.rejected, (state, action) => {
                state.errors.list = action.error;
            })
            .addCase(createAdminThunk.fulfilled, (state, action) => {
                adminAdapter.upsertOne(state, action.payload);
                state.errors[action.payload.id] = undefined;
            })
            .addCase(createAdminThunk.rejected, (state, {error}) => {
                state.errors.create = error;
            })
            .addCase(updateAdminThunk.fulfilled, (state, action) => {
                const {id, ...changes} = action.payload;
                adminAdapter.updateOne(state, {id, changes});
                state.errors[action.payload.id] = undefined;
            })
            .addCase(updateAdminThunk.rejected, (state, action) => {
                state.errors[action.meta.arg.id] = action.error;
            })
            .addCase(updateAdminStatusThunk.fulfilled, (state, action) => {
                const {id, ...changes} = action.payload;
                adminAdapter.updateOne(state, {id, changes});
                state.errors[action.payload.id] = undefined;
            })
            .addCase(updateAdminStatusThunk.rejected, (state, action) => {
                state.errors[action.meta.arg.id] = action.error;
            })
            .addCase(getAdminThunk.fulfilled, (state, action) => {
                adminAdapter.upsertOne(state, action.payload);
                state.errors[action.payload.id] = undefined;
            })
            .addCase(getAdminThunk.rejected, (state, action) => {
                state.errors[action.meta.arg.id] = action.error;
            })
})

export const {
    selectById: selectAdminById,
    selectIds: selectAdminIds,
    selectEntities: selectAdminEntities,
    selectAll: selectAllAdmins,
    selectTotal: selectTotalAdmins,
} = adminAdapter.getSelectors((state: RootState) => state.admins);

export const {clearAllAdminErrors} = adminsSlice.actions;

export default adminsSlice.reducer;
